module.exports = __webpack_public_path__ + "img/sushi-king-menu-2024-01.b9dd2fb6.png";